import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { raceSeriesAPI } from '@/services/raceSeriesApi';
import { queryKeys } from './queryKeys';

export function useRaceSeries() {
  return useQuery({
    queryKey: queryKeys.series.all(),
    queryFn: () => raceSeriesAPI.getCmsSeries(),
  });
}

export function usePublicSeries() {
  return useQuery({
    queryKey: ['public-series'],
    queryFn: () => raceSeriesAPI.getSeries(),
  });
}

export function usePublicSeriesById(id?: any) {
  return useQuery({
    queryKey: ['public-series', id],
    queryFn: () => raceSeriesAPI.getSeriesById(id),
    enabled: !!id,
  });
}

export function useCreateSeries() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => raceSeriesAPI.createSeries(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.series._def }),
  });
}

export function useUpdateSeries() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => raceSeriesAPI.updateSeries(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.series._def }),
  });
}

export function useDeleteSeries() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => raceSeriesAPI.deleteSeries(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.series._def }),
  });
}
